var tab;

tab = function() {
  var $, activeClass, btn, content, module, moduleName, toggleTab;
  $ = require('jquery');
  moduleName = 'tab';
  module = $("." + moduleName);
  activeClass = 'active';
  btn = module.find("." + moduleName + "__btn");
  content = module.find("." + moduleName + "__desc-item");
  toggleTab = function(obj) {
    var thisData;
    obj.addClass(moduleName + "__btn--" + activeClass);
    obj.siblings().removeClass(moduleName + "__btn--" + activeClass);
    thisData = obj.data("" + moduleName);
    return content.each(function() {
      var thisContent, thisContentData, timeout;
      thisContent = $(this);
      thisContentData = thisContent.data("" + moduleName);
      if (thisContentData === thisData) {
        timeout = 300;
        thisContent.siblings().fadeOut(timeout).removeClass(moduleName + "__desc-item--" + activeClass);
        btn.css('pointerEvents', 'none');
        return setTimeout(function() {
          btn.css('pointerEvents', 'auto');
          thisContent.fadeIn(timeout);
          return thisContent.addClass(moduleName + "__desc-item--" + activeClass);
        }, timeout);
      }
    });
  };
  return btn.click(function() {
    var thisBtn;
    thisBtn = $(this);
    return toggleTab(thisBtn);
  });
};

module.exports = tab;
